<template>
    <v-dialog v-model="editorShownUnableflight" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid red;">
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-ban"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected UnableFlight List ------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/UnableFlights:</strong></div>
            <selected-unable-flight-list v-model="employees" v-if="editorShownUnableflight" />

            <v-divider style="margin-top: 20px;"></v-divider>

           <!-- Selecting UnableFlight -------------------------------------- -->
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Unable to fly - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Unable to fly  - to" disabled="true" disabledTime="true" ref="endTimer" />

                <comment-textarea v-model="dutyComment" label="Unableflight Info:" maxlength="200" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('UNABLEFLIGHT').length }} UnableFlight(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_UnableFlightDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_UnableflightUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid red">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-ban"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownUnableflight" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting UnableFlight ------------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-ban"></i><strong>Build your Unable Flight:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Unable to fly - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Unable to fly  - to" disabled="false" disabledTime="true" ref="endTimer" />

                <comment-textarea v-model="dutyComment" label="Unableflight Info:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_UnableFlightDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_UnableflightCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedUnableFlightList from '../../SelectedUnableFlightList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-unableflight',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownUnableflight
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            CommentTextarea,
            SelectedUnableFlightList,
            SelectedEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_selectedMultiResources',
                'get_selectedMultiEvents',
                'get_shared_IsEditingInThePastAllowed',
            ]),


            /*******************************************************************
            * editorShownUnableflight()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownUnableflight: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/unableflight/EventEditor.vue >>> editorShownUnableflight get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    dutyComment     : null
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownUnableflight get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/unableflight/EventEditor.vue >>> editorShownUnableflight set');
                    this.$emit('input', value);

                } // eo editorShownUnableflight set

            } // eo function editorShownUnableflight()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updateunableflight'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> created');
            eventBus.$on('updateunableflight', this.onUpdate_SingleDuty); // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updateunableflight', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty',
                'actn_update_Multiple_Duty',
                'actn_update_SingleDuty', // Call: Modify Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_UnableflightUpdate()
            *
            * Desc: 'Update Standby(s)' - Call.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_UnableflightUpdate: function() {

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> onSave_UnableflightUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(employee.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                        to: moment(employee.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                        type: 'UNABLEFLIGHT',
                        status: 'PLANNED',
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });


                if (this.validateParams(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                }

            }, // eo function onSave_UnableflightUpdate()


            /*******************************************************************
            * onSave_UnableflightCreate()
            *
            * Desc: 'Create Standby(s)' - Call.
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_UnableflightCreate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> onSave_UnableflightCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    // idResource      : this.resourceRecord.id,
                    idResources     : this.employees,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'UNABLEFLIGHT',
                    status          : 'PLANNED',
                    split           : true,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_UnableflightCreate()


            /*******************************************************************
            * onClose_UnableFlightDialog()
            *
            * Desc: Close Standby Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_UnableFlightDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> onClose_UnableFlightDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownUnableflight = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_UnableFlightDialog()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'modifysingleduty' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response) {

                let me = this,
                    params = {},
                    tooltiptData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ dutyComment: me.dutyComment });

                tooltiptData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltiptData.nameEvent });
                me.eventRecord.set({ note: tooltiptData.note });

                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor now ...
                me.editorShownUnableflight = false;

            }, // eo function onUpdate_SingleDuty()



            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note: Do nothing here. Dont set END like START Date (like in DAYOFF).
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> onChange_DatePicker');
                newDate = new Date(value);
                newDate.setHours(23);
                newDate.setMinutes(59);
                me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc:
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/unableflight/EventEditor.vue >>> validateParams');
                startDate = moment(params.from);
                endDate = moment(params.to);

                if (endDate.isBefore(startDate)) {
                    valid = false;
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                } else {
                    valid = true;
                }


                return valid;

            }, // eo function validateParams()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
